import axiosInstance from 'axios'
import { API_URL } from './constants'

const axios = axiosInstance.create({
	baseURL: API_URL,
	headers: {
		'Accept-Language': localStorage.getItem('lang') || 'ar'
	}
	
});

export default axios;
